/* eslint-disable no-eval */
import publicConfig from "@FRAMEWORK/config/public";
import {useRouter} from "next/router";
import {useCallback, useEffect, useState} from "react";
import TagManager from "react-gtm-module";
// import ReactGA from "react-ga";
import {amplitude, braze, device} from "@kit/utils";
import usePagesPaths from "@kit/utils/dist/usePagesPaths";

const GoogleTagManager = () => {
	const router = useRouter();
	const [isMobile, setIsMobile] = useState(device.current() === "Mobile");

	useEffect(() => {
		if (publicConfig.RUNTIME_ENV === "local") {
			window.dataLayer = [];
			return;
		}

		const gtmId = isMobile ? "GTM-PNLBTDT" : "GTM-N769DH4";
		const dataLayerName = "PageDataLayer";
		TagManager.initialize({gtmId});
		TagManager.dataLayer({dataLayerName});
	}, [isMobile]);

	useEffect(() => {
		const handleRouteChange = () => {
			const newIsMobile = device.current() === "Mobile";
			if (newIsMobile !== isMobile) {
				setIsMobile(newIsMobile);
			}
		};
		router.events.on("routeChangeComplete", handleRouteChange);
		return () => {
			router.events.off("routeChangeComplete", handleRouteChange);
		};
	}, [router, isMobile]);

	return null;
};

// const GoogleAnalytics = () => {
// 	const router = useRouter();
// 	const [init, setInit] = useState(false);
// 	/** GoogleAnalytics Init */
// 	useEffect(() => {
// 		ReactGA.initialize("UA-38764293-1", {debug: false});
// 		setInit(true);
// 	}, []);
// 	/** GoogleAnalytics */
// 	useEffect(() => {
// 		if (init) {
// 			ReactGA.ga("set", "dimension2", "home");
// 			ReactGA.ga("send", "pageview");
// 		}
// 	}, [router, init]);
// 	return null;
// };

const PaMaInitializer = () => {
	usePagesPaths();
	const init = useCallback(async () => {
		try {
			const returnBrazeInit = await braze.initialize();
			if (returnBrazeInit) {
				amplitude.init();
				// braze.requestPushPermissionCustom();
			}
		} catch (e) {}
	}, []);

	useEffect(() => {
		init();
		window.tagging = window.tagging || {};
	}, [init]);

	// taggingJS
	// useEffect(() => {
	// 	taggingJS();
	// }, []);

	// // taggingJS routing
	// useEffect(() => {
	// 	router.events.off("routeChangeComplete", taggingJS);
	// 	router.events.on("routeChangeComplete", taggingJS);
	// 	return () => router.events.off("routeChangeComplete", taggingJS);
	// }, [router]);

	return <></>;
};

// const Adinsight = () => {
// 	const TRS_PROTOCOL = document.location.protocol;
// 	const src = `${TRS_PROTOCOL}//${
// 		TRS_PROTOCOL === "https:" ? "analysis.adinsight.co.kr" : "adlog.adinsight.co.kr"
// 	}/emnet/trs_esc.js`;

// 	useEffect(() => {
// 		const script = document.createElement("script");
// 		script.src = src;
// 		document.head.insertBefore(script, document.head.firstChild);
// 	}, []);

// 	useEffect(() => {
// 		const script = document.createElement("script");
// 		script.text = `
// 			var TRS_AIDX = 11087;
// 		`;
// 		document.head.insertBefore(script, document.head.firstChild);
// 	}, []);

// 	return <></>;
// };

// const NethruLogger = () => {
// 	const router = useRouter();
// 	const [init, setInit] = useState(false);
// 	let serviceId = device.current() === "Mobile" ? "pk_mweb" : "pk_web";
// 	device.isYBApp() && (serviceId = "pk_app");
// 	["development", "local", "publish"].indexOf(publicConfig.RUNTIME_ENV) > -1 && (serviceId = `${serviceId}_dev`);

// 	/** 넷스루 Init */
// 	useEffect(() => {
// 		const script = document.createElement("script");
// 		script.type = "text/javascript";
// 		script.src = "//static.ybtour.com/js/nlogger.js";
// 		document.head && document.head.insertBefore(script, document.head.firstChild);
// 		script.onload = () => {
// 			Nethru.Settings.serviceId = serviceId;
// 			setInit(true);
// 			nLogger.log();
// 		};
// 	}, []);

// 	/** 페이지 마다 로깅 */
// 	useEffect(() => {
// 		if (!init) return;
// 		nLogger.log();
// 	}, [router]);

// 	return null;
// };

const Provider = ({children}) => (
	<>
		{children}
		<PaMaInitializer />
		<GoogleTagManager />
		{/* <NethruLogger /> */}
		{/* <GoogleAnalytics /> */}
		{/* <Adinsight /> */}
	</>
);

export default Provider;
